import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

// project import
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

import Loadable from 'components/Loadable';

import AuthLayout from 'layout/Auth';

// render - landing page
const JwtAuthLogin = Loadable(lazy(() => import('pages/auth/jwt/login')));
const PublicOPDBooking = Loadable(lazy(() => import('pages/public/OPDBooking')));
const PublicHealthPackageBooking = Loadable(lazy(() => import('pages/public/HealthPackageBooking')));
const PublicDonate = Loadable(lazy(() => import('pages/public/Donate')));

// headless PDF rendering used by the backend (see pages/print/PrintDocument)
const PrintDocument = Loadable(lazy(() => import('pages/print/PrintDocument')));

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        {
          index: true,
          element: <JwtAuthLogin />,
        }
      ]
    },
    {
      path: '/print/:type/:id',
      element: <PrintDocument />
    },
    LoginRoutes,
    {
      path: '/opd-booking',
      element: <PublicOPDBooking />,
    },
    {
      path: '/health-package-booking',
      element: <PublicHealthPackageBooking />,
    },
    {
      path: '/donate',
      element: <PublicDonate />,
    },
    MainRoutes
  ],
  { basename: process.env.REACT_APP_BASE_NAME }
);

export default router;
